import { z } from 'zod';
import type { TFunction } from 'i18next';

export function createChangePasswordSchema(t: TFunction) {
  return z
    .object({
      currentPassword: z
        .string()
        .min(1, t('validation.current_password_required')),
      newPassword: z
        .string()
        .min(8, t('validation.new_password_min'))
        .regex(/[a-zA-Z]/, t('validation.password_letter'))
        .regex(/[0-9]/, t('validation.password_number')),
      confirmNewPassword: z
        .string()
        .min(1, t('validation.confirm_new_password_required')),
    })
    .refine((data) => data.newPassword === data.confirmNewPassword, {
      message: t('validation.passwords_mismatch'),
      path: ['confirmNewPassword'],
    });
}

export type ChangePasswordFormValues = z.infer<ReturnType<typeof createChangePasswordSchema>>;
